module.exports = __webpack_public_path__ + "static/media/trophy.c7f3bdfc.svg";